import { CustomProperty, CustomPropertyType } from '@evidentid/tprm-portal-lib/models/dashboard';

// The types Go App employees can search by; the backend rejects any other lookup property.
export const GO_APP_LOOKUP_TYPES: CustomPropertyType[] = [
    CustomPropertyType.string,
    CustomPropertyType.integer,
    CustomPropertyType.number,
];

// The types the Go App has an input for when adding an entity.
export const GO_APP_COLLECTABLE_TYPES: CustomPropertyType[] = [
    CustomPropertyType.string,
    CustomPropertyType.email,
    CustomPropertyType.integer,
    CustomPropertyType.number,
    CustomPropertyType.boolean,
    CustomPropertyType.enum,
];

export function compareByName(a: CustomProperty, b: CustomProperty): number {
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
}

/**
 * Required properties the Go App has no input for, other than the lookup property. No entity added
 * from the app could carry one, so the backend refuses to save while adding entities is on.
 */
export function requiredUncollectableProperties(
    customProperties: CustomProperty[],
    lookupFieldKey: string | null,
): CustomProperty[] {
    return customProperties.filter((property) =>
        property.required &&
        property.key !== lookupFieldKey &&
        !GO_APP_COLLECTABLE_TYPES.includes(property.type));
}
